@if (route$ | async; as route) {
  <div class="layout-row full gap-sm p-sm">
    @for (segment of route.segments; track segment) {
      <div class="layout-col segment">
        <div class="layout-row gap-sm">
          @for (operationCap of segment.actions; track operationCap) {
            <div class="action">
              <span class="text-body-medium">{{ operationCap?.action }}</span>
            </div>
          }
        </div>
        <span class="text-label-medium" matTooltip="{{ segment?.capabilityName }}">{{
          segment?.workCenterName
        }}</span>
      </div>
    }
  </div>
}
